<template>
    <v-dialog v-model="shows" width="480" persistent>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card light>
            <v-card-title> {{ title }} <v-spacer /> <v-icon @click="shows = false">mdi-close</v-icon> </v-card-title>
            <v-card-text class="py-5">
                <v-row class="ma-n2">
                    <v-col class="pa-2" cols="12">
                        <v-data-table
                            v-bind="{
                                items,
                                headers,
                                itemsPerPage: -1,
                                mobileBreakpoint: 9999,
                            }"
                            dense
                            hide-default-footer
                            disable-pagination
                            disable-sort
                            class="v-sheet--outlined"
                        >
                            <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :class="header.class" v-html="header.formatter.bind(item)(value, item)" /> </template>
                        </v-data-table>
                    </v-col>
                    <v-col class="pa-2" cols="12">
                        <code class="d-block px-4 py-2 text-start text-pre-wrap">{{ value }}</code>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { initDataTableHeaders } from "@/assets/lib";
export default {
    components: {},
    props: {
        value: { type: Object, default: () => ({}) },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        title() {
            let title = "나누리싱픔권 가상계좌 입금 상세";
            return title;
        },
        items() {
            return [this.value];
        },
        headers() {
            /** @type {import('@/assets/lib').Header[]} */
            let headers = [
                {
                    text: "생성일시",
                    value: "createdAt",
                    formatterType: "datetime",
                },
                {
                    text: "거래유형",
                    value: "kind",
                },
                {
                    text: "거래번호",
                    value: "transactionNo",
                },
                {
                    text: "거래금액",
                    value: "paymentAmount",
                    formatterType: "number",
                    formatterSuffix: "원",
                },
                {
                    text: "주문번호",
                    value: "orderNo",
                },
                {
                    text: "응답코드",
                    value: "resCode",
                },
                {
                    text: "응답메시지",
                    value: "resMessage",
                },
            ];
            return initDataTableHeaders(headers);
        },
    },
    methods: {},
    watch: {},
};
</script>
<style lang="scss" scoped>
.text-pre-wrap {
    white-space: pre-wrap;
}
</style>
